import axios from '../axios'

/**
 * 保存
 * @param {*} data 
 * district	是	string	行政区划 /如果是驾校分类， 此字段取驾校列表中的district /如果是合作伙伴分类，则取选择地区
    id	否	string	商户管理Id 编辑时必传
    isShare	是	string	是否开通分账 Y:开通 N:关闭
    mchId	是	string	商户号
    name	是	string	微信商户全名称 / 如果是驾校分类 取驾校名称 /如果是合作伙伴分类 自己输入
    schoolId	否	string	驾校id /如果是驾校分类 次字段传 /如果是合作伙伴分类 不传
    type	是	string	商户类型 1：驾校 2：合作伙伴
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059634  20220517 
 */
export const save = data => {
  return axios({
    url: '/merchantmanage/save',
    method: 'post',
    data,
  })
}
/**
 * 分页查询 商户号列表
 * @param {*} data 
 * type	否	string	商户类型 1：驾校 2：合作伙伴
    district	否	string	行政区划
    name	否	string	微信商户全名称
    mchId	否	string	商户号
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059632  20220517
 */
export const page = data => {
  return axios({
    url: '/merchantmanage/list',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/merchant.js